var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('div',{staticClass:"content"},[_c('header',[_c('e-row',{attrs:{"mr":""}},[_c('e-col',[_c('h2',{staticClass:"component-title"},[_vm._v("Gravações do leilão")])]),_c('e-col',{staticClass:"text-right"})],1)],1),_c('div',{staticClass:"body"},[_vm._v(" Em breve você poderá solicitar gravações dos leilões. ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }